module.exports = __webpack_public_path__ + "media/src/assets/Images/Marker-8bef19bf4b62487af2ee897be372447d.svg";